import toast from 'react-hot-toast';
import { CustomToast } from '.';

type ToastType = 'success' | 'error' | 'info' | 'warning' | 'custom';

export interface CustomToastOptions {
  content: string;
  appearance?: ToastType;
  autoDismiss?: boolean;
  duration?: number;
}

export const showCustomToast = ({
  content,
  appearance = 'custom',
  autoDismiss = true,
  duration,
}: CustomToastOptions) => {
  const id = toast.custom(
    (t) => (
      <CustomToast
        message={content}
        type={appearance}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    {
      id: undefined,
      duration: autoDismiss ? duration ?? 3000 : Infinity,
    }
  );

  return id;
};

export const updateCustomToast = (
  id: string,
  {
    content,
    appearance = 'custom',
    autoDismiss = true,
    duration,
  }: CustomToastOptions
) => {
  toast.custom(
    (t) => (
      <CustomToast
        message={content}
        type={appearance}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    {
      id,
      duration: autoDismiss ? duration ?? 3000 : Infinity,
    }
  );
};
